import React, { useLayoutEffect, useMemo, useState } from "react";
import { gsap } from "gsap";

const tabs = [
  {
    id: 1,
    image: require("../../assets/images/vyapar.svg"),
    content: {
      image: require("../../assets/images/merlyn-vyapar.jpeg"),
      name: "Merlyn Mathew",
      position: "Data Analyst, Vyapar",
      message:
        '"Datazip was a life saviour for us. Easy to setup, highly scalable and solved all of our data related problems of combining different data sources and analysing them with ease. Kudos to the team."',
    },
  },
  {
    id: 2,
    image: require("../../assets/images/growpital.svg"),
    content: {
      image: require("../../assets/images/utkarsh_srivastava.png"),
      name: "Utkarsh Srivastava",
      position: "Chief Business Officer, Growpital",
      message:
        '"At Growpital we had the complexity of data generated from two different industries, finance and agriculture, datazip helped us to uniform the data from different formats of specific industries. With many teams at our company relying on data, having a streamlined data infrastructure in place allows us to focus on improving key business metrics and increasing our impact."',
    },
  },
  {
    id: 3,
    image: require("../../assets/images/pagarbook.svg"),
    content: {
      image: require("../../assets/images/mayank-pagarbook.jpeg"),
      name: "Mayank Vyas",
      position: "Product team, Pagarbook",
      message:
        '"Datazip got us to our desired efficiency level very quickly. I can rely on their infrastructure and have the confidence that I will get all my data from multiple sources in one place in the desired time frame. Additionally, Datazip eliminates the human effort to set up integrations and manage a data warehouse, so now I can focus on extracting insights. I also appreciate the quick support."',
    },
  },
  {
    id: 4,
    image: require("../../assets/images/limechat.webp"),
    content: {
      image: require("../../assets/images/nikhil-limechat.jpeg"),
      name: "Nikhil Gupta",
      position: "Co-founder, Limechat",
      message:
        '"Finding the right data engineer is a time taking process and over and above setting up a robust data infrastructure that can scale as requirements grow would easily take 3-4 months. With Datazip we can actually leapfrog our data capabilities. Datazip also offers powerful data exploring features, much needed for us as we need to build insights from the data we get from many businesses."',
    },
  },
];

const Testimonial = () => {
  const [selected, setSelected] = useState(1);
  const { content } = useMemo(
    () => tabs.filter((tab) => tab.id === selected)[0],
    [selected]
  );

  useLayoutEffect(() => {
    gsap.fromTo(
      ".tab-content",
      { opacity: 0, y: "1rem" },
      {
        opacity: 1,
        y: "0rem",
        scrollTrigger: {
          trigger: ".testimonial",
          start: "top 60%",
        },
      }
    );
  }, [selected]);
  return (
    <div className="testimonial">
      <div className="tabs">
        {tabs.map((tab) => {
          return (
            <div
              className={`tab ${tab.id === selected ? "selected" : ""} `}
              key={tab.id}
              onClick={() => setSelected(tab.id)}
            >
              <img src={tab.image} alt="" />
            </div>
          );
        })}
      </div>
      <div className={`tab-content`}>
        <div className="tab-content-message">{content?.message}</div>
        <div className="tab-content-user">
          <img src={content?.image} alt="user_photo" />
          <div className="name">{content?.name}</div>
          <div className="position">{content?.position}</div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
